import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CREATE_GTM_PROJECT } from "../graphql";
import ProjectTasksView from "../projectTasks/ProjectTasksView";
import ProjectContext from "./ProjectContext";

const GTMProjectsView = () => {
  const { originalProject } = useContext(ProjectContext);

  const navigate = useNavigate();
  const [createGTMProject, createGTMProjectRes] = useMutation(
    CREATE_GTM_PROJECT,
    {
      onCompleted(data) {
        navigate(
          `/development/gtm-projects/${data.createGtmProject.gtmProject.id}`,
        );
      },
      onError(error) {
        Alert("error", parseError(error));
      },
    },
  );

  function createGTMProjectHandler() {
    if (!originalProject.owner) {
      window.alert("Please set a product owner before shipping to GTM.");
      return;
    }

    if (window.confirm("Are you sure you want to ship to GTM?")) {
      createGTMProject({
        variables: {
          name: originalProject.name,
          startUpProjectId: originalProject.id,
        },
      });
    }
  }

  return (
    <div className="card space-y-2">
      <div>
        <h5>GTM Project</h5>
      </div>

      {originalProject.gotomarketproject && (
        <div className="space-y-4">
          <div className="text-sm">
            <Link
              to={`/development/gtm-projects/${originalProject.gotomarketproject.id}`}
              target="_blank"
            >
              GTM: {originalProject.gotomarketproject.name}
            </Link>
          </div>

          <ProjectTasksView
            projectId={originalProject.gotomarketproject.id}
            projectType="GTM"
          />
        </div>
      )}

      {!originalProject.gotomarketproject && (
        <Button
          onClick={createGTMProjectHandler}
          loading={createGTMProjectRes.loading}
        >
          Ship to GTM
        </Button>
      )}
    </div>
  );
};

export default GTMProjectsView;
